import { myInput } from '../input.js';
import { utils } from '../utils.js';
import { myToolbar } from './toolbar.js';
import { beads } from '../beads.js';
import { modes } from '../modes.js';

export const marquee = {};

const getCurrentlySelectedBeads = () => beads.arr.filter(bead => {
    if (bead.ignore || bead.hidden) return false;
    return bead.selected;
});

// User clicks to start a marquee
marquee.launch = () => {

    // record currently selected beads if shift is down, otherwise unselect beads
    if (myInput.SHIFT.isDown) {
        beads.previouslySelectedBeads = getCurrentlySelectedBeads();
    } else {
        beads.unselectAll();
    }

    // set marquee starting position, and rotation
    const myPoint = utils.returnPoint();
    beads.marquee
        .setX(myPoint.x)
        .setY(myPoint.y)
        .setRotation(- game.cameras.main.rotation)

    // start marquee mode
    modes.start('draw marquee');
};

const getMarqueeScale = () => {
    const myPoint = utils.returnPoint();
    const [w, h] = [myPoint.x - beads.marquee.x, myPoint.y - beads.marquee.y];
    const dist = Math.sqrt((w * w) + (h * h));
    const theta = utils.myArcTan(w, h) + beads.marquee.rotation;
    const [scaleX, scaleY] = [-(dist * Math.cos(theta)), dist * Math.sin(theta)];
    return [scaleX / 10, scaleY / 10];
};

// resize marquee as mouse moves
const setMarqueeFromPointer = () => {
    const myScale = getMarqueeScale();

    beads.marquee
        .setAlpha(isNaN(myScale[0]) ? 0 : 0.3) // fixes bug of phantom marquee appearing when camera is straight
        .setScale(...myScale);
};

const beadIsInMarquee = ({bead, midpoint, canvasAngle, scale}) => {

    const xd = bead.x - midpoint.x;
    const yd = bead.y - midpoint.y;
    const dist = Math.sqrt((xd * xd) + (yd * yd));
    const theta = utils.myArcTan(xd, yd) + canvasAngle;
    const _x = Math.abs(dist * Math.cos(theta));
    const _y = Math.abs(dist * Math.sin(theta));

    return (
        _x < Math.abs(scale[1] / 2) &&
        _y < Math.abs(scale[0] / 2)
    );
};

// process mouse button up
const terminateMarquee = () => {
    const scale = getMarqueeScale().map(e => e * 10);
    const myPoint = utils.returnPoint();
    const canvasAngle = game.cameras.main.rotation - (Math.PI / 2);
    const midpoint = {
        x: (beads.marquee.x + myPoint.x) / 2,
        y: (beads.marquee.y + myPoint.y) / 2
    };

    // select beads inside marquee, otherwise unselect (unless shift is down)
    beads.arr.forEach(bead => {
        if (bead.ignore || bead.hidden || !bead.active) return;
        if (beadIsInMarquee({bead, midpoint, canvasAngle, scale})) {
            beads.select(bead);
        } else if (!beads.previouslySelectedBeads.includes(bead)) {
            beads.unselect(bead);
        }
    });

    // hide marquee
    beads.marquee.setAlpha(0);
    modes.start('marquee');
};

// Called during marquee mode
marquee.draw = () => {
    if (game.input.activePointer.isDown) {
        setMarqueeFromPointer();
    } else {
        terminateMarquee();
    }
};